/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobAcceptedResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type JobAcceptedResponse } from '../../../../models/index.js';
// @ts-ignore
import { ProgressRequestBuilderNavigationMetadata, type ProgressRequestBuilder } from './progress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/images/housekeeping/scan
 */
export interface ScanRequestBuilder extends BaseRequestBuilder<ScanRequestBuilder> {
    /**
     * The progress property
     */
    get progress(): ProgressRequestBuilder;
    /**
     * Finds the organization's abandoned stored assets - images that still exist in storage but have no image document and no flipbook page referencing them - and lists the assets currently in its trash. The scan is queued and this returns immediately with a tracking id; poll the returned status URI for the findings. Only the caller's organization is scanned.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobAcceptedResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobAcceptedResponse | undefined>;
    /**
     * Finds the organization's abandoned stored assets - images that still exist in storage but have no image document and no flipbook page referencing them - and lists the assets currently in its trash. The scan is queued and this returns immediately with a tracking id; poll the returned status URI for the findings. Only the caller's organization is scanned.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ScanRequestBuilderUriTemplate = "{+baseurl}/api/images/housekeeping/scan";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ScanRequestBuilderNavigationMetadata: Record<Exclude<keyof ScanRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    progress: {
        navigationMetadata: ProgressRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ScanRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ScanRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobAcceptedResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
